import { workApprovalProxy } from './index';

// 신청서 공통 저장
function applovalCommonSave(params) {
  return workApprovalProxy.post('common/save', { params });
}

// fileSeq 조회
function getFileSeq(params) {
  return workApprovalProxy.get('common/getfileseq', { params });
}

// 신청서 정보 조회
function getUiInfo(params) {
  return workApprovalProxy.get('common/getuiinfo', { params });
}

export { applovalCommonSave, getFileSeq, getUiInfo };
